// extracted by mini-css-extract-plugin
export default {"clausesTemplateHeader":"styles_clausesTemplateHeader__3PbDo","clausesTabsPane":"styles_clausesTabsPane__ym6Al","clausesEmptyTemplates":"styles_clausesEmptyTemplates__ZQOEz"};